var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "lbv-leak-list animated fadeIn roundedCard" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-12" },
          [
            _c(
              "b-card",
              [
                _c("div", { staticClass: "col-lg-12 leak-list-header" }, [
                  _c("span", { staticClass: "lbv-page-title" }, [
                    _vm._v("Leak List"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row secondary lbv-search" }, [
                  _c(
                    "form",
                    {
                      staticClass: "lbv-search-filter leak-list-form",
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.search.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "leaklistFilters w-100" },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Device ID",
                                        "label-for": "device-id",
                                      },
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.searchDeviceID,
                                            expression: "searchDeviceID",
                                          },
                                        ],
                                        staticClass: "form-control full-width",
                                        attrs: {
                                          id: "device-id",
                                          type: "text",
                                          placeholder: "LeakBot ID",
                                        },
                                        domProps: { value: _vm.searchDeviceID },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.searchDeviceID =
                                              $event.target.value
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Tenant",
                                        "label-for": "tenant-id",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-form-select",
                                        {
                                          staticClass: "full-width",
                                          attrs: { id: "tenant-id" },
                                          model: {
                                            value: _vm.tenantSelection,
                                            callback: function ($$v) {
                                              _vm.tenantSelection = $$v
                                            },
                                            expression: "tenantSelection",
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { domProps: { value: null } },
                                            [
                                              _vm._v(
                                                "\n                        All Tenants\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.tenants,
                                            function (tenant) {
                                              return _c(
                                                "option",
                                                _vm._b(
                                                  {
                                                    key: tenant.id,
                                                    domProps: {
                                                      value: { id: tenant.id },
                                                    },
                                                    on: {
                                                      option: function (
                                                        $event
                                                      ) {
                                                        return _vm.$emit(
                                                          "option",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  },
                                                  "option",
                                                  _vm.$attrs,
                                                  false
                                                ),
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(tenant.name) +
                                                      "\n                      "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Need Help",
                                        "label-for": "need-help",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-form-select",
                                        {
                                          staticClass: "full-width",
                                          attrs: { id: "need-help" },
                                          model: {
                                            value: _vm.typeSelection,
                                            callback: function ($$v) {
                                              _vm.typeSelection = $$v
                                            },
                                            expression: "typeSelection",
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { domProps: { value: null } },
                                            [
                                              _vm._v(
                                                "\n                        All\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "AllFixed" } },
                                            [
                                              _vm._v(
                                                "\n                        All Fixed\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "CustomerRepaired",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        Customer Repaired\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "DrippingTap" } },
                                            [
                                              _vm._v(
                                                "\n                        Dripping Tap\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "FixMyself" } },
                                            [
                                              _vm._v(
                                                "\n                        Fix Myself\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "GetHelp" } },
                                            [
                                              _vm._v(
                                                "\n                        Get Help\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            {
                                              attrs: { value: "KnowWhatItIs" },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        Know What It Is\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            {
                                              attrs: { value: "LeakingToilet" },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        Leaking Toilet\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "NoneOfThese" } },
                                            [
                                              _vm._v(
                                                "\n                        None Of These\n                      "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "3" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Date from",
                                        "label-for": "date-from",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        staticClass: "date-picker w-100",
                                        attrs: {
                                          id: "date-from",
                                          type: "date",
                                          name: "dateFrom",
                                          placeholder: "YYYY-MM-DD",
                                        },
                                        model: {
                                          value: _vm.dateFrom,
                                          callback: function ($$v) {
                                            _vm.dateFrom = $$v
                                          },
                                          expression: "dateFrom",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "3" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Date to",
                                        "label-for": "date-to",
                                      },
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.dateTo,
                                            expression: "dateTo",
                                          },
                                        ],
                                        staticClass:
                                          "form-control date-picker w-100",
                                        attrs: {
                                          id: "date-to",
                                          type: "date",
                                          name: "dateTo",
                                          placeholder: "YYYY-MM-DD",
                                        },
                                        domProps: { value: _vm.dateTo },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.dateTo = $event.target.value
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "3" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Status",
                                        "label-for": "status-filter",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-form-select",
                                        {
                                          staticClass: "full-width",
                                          attrs: { id: "status-filter" },
                                          model: {
                                            value: _vm.statusSelection,
                                            callback: function ($$v) {
                                              _vm.statusSelection = $$v
                                            },
                                            expression: "statusSelection",
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { domProps: { value: null } },
                                            [
                                              _vm._v(
                                                "\n                        All\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "open" } },
                                            [
                                              _vm._v(
                                                "\n                        open\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "closed" } },
                                            [
                                              _vm._v(
                                                "\n                        closed\n                      "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "d-flex align-items-center",
                                  attrs: { cols: "3" },
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "w-100 mr-3",
                                      attrs: {
                                        id: "applyBtn",
                                        type: "submit",
                                        variant: "primary",
                                        disabled: _vm.applyBtnDisabled,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    Apply\n                  "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "w-100",
                                      attrs: {
                                        type: "submit",
                                        variant: "primary",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.downloadReport.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("span", { staticClass: "download" }, [
                                        _vm._v("Export CSV File"),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "b-alert",
                  {
                    attrs: { show: _vm.errorMessage != "", variant: "danger" },
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(_vm.errorMessage) + "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("b-table", {
                  attrs: {
                    small: "",
                    responsive: "",
                    striped: "",
                    hover: "",
                    items: _vm.deviceList,
                    fields: _vm.fields,
                    "per-page": _vm.perPage,
                    "current-page": _vm.currentPage,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "leakbotId",
                      fn: function (data) {
                        return [
                          _c(
                            "router-link",
                            {
                              staticClass: "deviceLink",
                              attrs: {
                                to: {
                                  name: "DeviceView",
                                  params: { deviceID: data.value },
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(data.value) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "needHelp",
                      fn: function (data) {
                        return [
                          data.item.needHelp === "GetHelp"
                            ? _c("strong", [_vm._v(_vm._s(data.value))])
                            : _c("div", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(data.value) +
                                    "\n            "
                                ),
                              ]),
                        ]
                      },
                    },
                    {
                      key: "repairComplete",
                      fn: function (data) {
                        return [
                          data.item.repairComplete === "GetHelp"
                            ? _c("strong", [_vm._v(_vm._s(data.value))])
                            : _c("div", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(data.value) +
                                    "\n            "
                                ),
                              ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "page prev",
                    attrs: {
                      variant: "primary",
                      size: "sm",
                      disabled: _vm.pageNumber === 1,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.page.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("\n          Prev\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "page next",
                    attrs: {
                      variant: "primary",
                      size: "sm",
                      disabled: !_vm.hasNextPage,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.page.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("\n          Next\n        ")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "current-page" }, [
                  _vm._v(
                    "\n          Page: " + _vm._s(_vm.pageNumber) + "\n        "
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }